import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: ""
};
import { addDecimal } from '@/utils/validate';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceTable',
  props: {
    modelValue: {
      type: Array,
      default: []
    },
    // 定价方案还是促销页面
    pageType: {
      type: String,
      default: 'pricingScheme' // pricingScheme 定价 promotionPlan 促销

    },
    // 是否显示操作列
    showOptions: {
      type: Boolean,
      default: true
    }
  },
  emits: ['on-edit-price', 'on-delete-price'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const tableConfig = reactive({
      data: props.modelValue,
      isCardBlock: false,
      loading: false,
      isShowHeader: false,
      showPageBar: false,
      columnList: [{
        label: '服务列表名称',
        prop: 'serviceListName',
        formatter: val => {
          switch (val) {
            case 1:
              return t('点播+直播VIP');

            case 2:
              return t('点播VIP');

            case 3:
              return t('直播VIP');

            case 4:
              return t('单片付费');

            default:
              return '';
          }
        }
      }, {
        label: '终端显示名称',
        prop: 'name'
      }, {
        label: '服务期',
        prop: 'servicePeriod',
        formatter: val => {
          return val + t('个月');
        }
      }]
    });
    const extraTableConfig = {
      'promotionPlan': [{
        label: '原价(美元)',
        prop: 'originalPrice'
      }, {
        label: '促销价格(美元)',
        prop: 'price'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '编辑',
          func: row => {
            emit('on-edit-price', row);
          }
        }, {
          label: '删除',
          func: row => {
            const {
              index
            } = row;
            emit('on-delete-price', index);
          }
        }],
        controller: () => {
          return props.showOptions;
        }
      }],
      'pricingScheme': [{
        label: '价格(美元)',
        prop: 'price',
        formatter: val => {
          if (val) {
            return `$${addDecimal(val)}`;
          }
        }
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '编辑',
          func: row => {
            emit('on-edit-price', row);
          }
        }, {
          label: '删除',
          func: row => {
            const {
              index
            } = row;
            emit('on-delete-price', index);
          }
        }],
        controller: () => {
          return props.showOptions;
        }
      }]
    };

    const changeTableColumnList = type => {
      tableConfig.columnList = [...tableConfig.columnList, ...extraTableConfig[type]];
    };

    const setOptionsBtnColumnWidth = width => {
      if (!props.showOptions) return;
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    watch(() => props.pageType, val => {
      console.log('props.pageType', val);
      changeTableColumnList(val);
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_common_table, {
        dynamicOption: __props.showOptions,
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["dynamicOption", "table-config", "pagination-config", "options"])]);
    };
  }

});